export const RPC_GIFT_ENDPOINTS = {
    GET_MY_GIFTS: "/get_my_gifts",
};
